export const dayStateBusy = "busy";
export const dayStateNotAvailable = "not-available";
export const dayStateFree = "free";

export type DayState = "busy" | "not-available" | "free";